<style lang="less">
.account-vue {
  .account-layout {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 24px;
    align-items: stretch;
  }

  .account-form-card,
  .account-info-show-vue {
    min-height: 460px;
    height: 100%;
    margin: 0;
  }

  @media (max-width: 900px) {
    .account-layout {
      grid-template-columns: 1fr;
    }
  }
}
</style>
<template>
  <div class="account-vue frame-page">
    <div class="account-layout">
      <AccountInfoShow v-model="account"></AccountInfoShow>
      <div class="h-panel account-form-card">
        <div class="h-panel-bar">
          <span class="h-panel-title">基本设置</span>
        </div>
        <AccountInfoEdit v-if="tab == 'info'" :account="account"></AccountInfoEdit>
      </div>
    </div>
  </div>
</template>
<script>
import AccountInfoEdit from './modules/account-info-edit';
import AccountInfoShow from './modules/account-info-show';
import { mapState } from 'vuex';

export default {
  components: {
    AccountInfoEdit,
    AccountInfoShow
  },
  data() {
    return {
      tab: 'info'
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {}
  },
  computed: {
    ...mapState({
      account: 'user'
    })
  }
};
</script>
